import React from "react";
import { IconWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function IconAdornment(_ref) {
  var icon = _ref.icon,
    color = _ref.color;
  var Component = icon;
  return /*#__PURE__*/_jsx(IconWrapper, {
    children: /*#__PURE__*/_jsx(Component, {
      color: color || "currentColor"
    })
  });
}